import React, { Component } from 'react';
import PropTypes from 'prop-types';
//import ReactRouterPropTypes from 'react-router-prop-types';
import { Link } from 'react-router-dom';

import { urls } from '../../utils/routing';

import { 
    ADMIN_PANEL_LINKES
} from '../AdminPanel/translations';

import styles from './LinksPanel.module.css';


export default class LinksPanel extends Component {
    static propTypes = {
        //history: ReactRouterPropTypes.history.isRequired,
        referrer: PropTypes.bool,
    }

    renderItem = (page) => {
        // check for link name
        if (page === 'admin-panel') {
            return (
                <li className={styles.breadcrumbs_item} key={page}>
                    <Link className={styles.breadcrumbs_link} to={{pathname: urls.adminSection}} state={{ lastUrl: document.location.href }}>{ADMIN_PANEL_LINKES(page)}</Link>
                </li>
            )
        } else if (page === 'mods') {
            return (
                <li className={styles.breadcrumbs_item} key={page}>
                    <Link className={styles.breadcrumbs_link} to={{pathname: urls.adminSection+page+'/'}} state={{ lastUrl: document.location.href }}>{ADMIN_PANEL_LINKES(page)}</Link>
                </li>
            )
        } else if (page === 'support') {
            return (
                <li className={styles.breadcrumbs_item} key={page}>
                    <Link className={styles.breadcrumbs_link} to={{pathname: urls.adminSection+page+'/'}} state={{ lastUrl: document.location.href }}>{ADMIN_PANEL_LINKES(page)}</Link>
                </li>
            )
        } else if (page === 'comments') {
            return (
                <li className={styles.breadcrumbs_item} key={page}>
                    <Link className={styles.breadcrumbs_link} to={{pathname: urls.adminSection+page+'/'}} state={{ lastUrl: document.location.href }}>{ADMIN_PANEL_LINKES(page)}</Link>
                </li>
            )
        } else if (page === 'users') {
            return (
                <li className={styles.breadcrumbs_item} key={page}>
                    <Link className={styles.breadcrumbs_link} to={{pathname: urls.adminSection+page+'/'}}>{ADMIN_PANEL_LINKES(page)}</Link>
                </li>
            )
        } else if (page.slice(0, 7) === 'Тикет №') {
            return (
                <li className={styles.breadcrumbs_item} key={urls.supportSectionTicketView.replace(/:slug/g, page.slice(8))}>
                    <Link className={styles.breadcrumbs_link} to={{pathname: urls.supportSectionTicketView.replace(/:slug/g, page.slice(8))}}>{page}</Link>
                </li>
            )
        } else {
            // document.referrer.replace(['https://localhost:3000', 'http://localhost:3000', 'https://tankimods.net'], '')
            return (
                <li className={styles.breadcrumbs_item} key={page}>
                    <Link className={styles.breadcrumbs_link} to={{pathname: urls.landing+`${page}/`}}>{page}</Link>
                </li>
            )
        }
    }

    render() {
        // this.history.location.pathname
        return (
            <ul className={styles.breadcrumbs} >
                {this.props.names.map((page) => this.renderItem(page))}
                {/* {this.props.names.map((page) => this.renderItem(page))} */}
            </ul>
        )
    }
}
